import { reactive } from 'vue';
import axios from 'axios';


export const authChecker = reactive({
    checkAuth(token, callback) {
        let baseURL = process.env.VUE_APP_API_URL;
        let headers = {
            'Content-type': 'application/json',
            'Authorization': token
        };
        
        axios
            .get(`${baseURL}v2/settings/car-types`, {
                'headers': headers
            })
            .then((response) => {
                if (response.status == 200) {
                    callback(true);
                } else {
                    callback(false);
                }
            })
            .catch(() => {
                callback(false);
            });
    },
});
